/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { FileDtoFromJSON, FileDtoToJSON, ServiceActionTypeDtoFromJSON, ServiceActionTypeDtoToJSON, ServiceStatusFromJSON, ServiceStatusToJSON, ServiceTaskDtoFromJSON, ServiceTaskDtoToJSON, } from './';
export function ServiceActionDtoFromJSON(json) {
    return ServiceActionDtoFromJSONTyped(json, false);
}
export function ServiceActionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'carId': !exists(json, 'carId') ? undefined : json['carId'],
        'carName': !exists(json, 'carName') ? undefined : json['carName'],
        'carPlate': !exists(json, 'carPlate') ? undefined : json['carPlate'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'serviceType': !exists(json, 'serviceType') ? undefined : ServiceActionTypeDtoFromJSON(json['serviceType']),
        'required': !exists(json, 'required') ? undefined : json['required'],
        'startDateTime': !exists(json, 'startDateTime') ? undefined : (new Date(json['startDateTime'])),
        'endDateTime': !exists(json, 'endDateTime') ? undefined : (new Date(json['endDateTime'])),
        'status': !exists(json, 'status') ? undefined : ServiceStatusFromJSON(json['status']),
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : json['attachments'].map(FileDtoFromJSON)),
        'tasks': !exists(json, 'tasks') ? undefined : (json['tasks'] === null ? null : json['tasks'].map(ServiceTaskDtoFromJSON)),
        'mainPhoto': !exists(json, 'mainPhoto') ? undefined : FileDtoFromJSON(json['mainPhoto']),
    };
}
export function ServiceActionDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'carId': value.carId,
        'carName': value.carName,
        'carPlate': value.carPlate,
        'name': value.name,
        'description': value.description,
        'serviceType': ServiceActionTypeDtoToJSON(value.serviceType),
        'required': value.required,
        'startDateTime': value.startDateTime === undefined ? undefined : (value.startDateTime.toISOString()),
        'endDateTime': value.endDateTime === undefined ? undefined : (value.endDateTime.toISOString()),
        'status': ServiceStatusToJSON(value.status),
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : value.attachments.map(FileDtoToJSON)),
        'tasks': value.tasks === undefined ? undefined : (value.tasks === null ? null : value.tasks.map(ServiceTaskDtoToJSON)),
        'mainPhoto': FileDtoToJSON(value.mainPhoto),
    };
}
